<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="10" class="center">
        <v-row align="center" justify="space-around">
          <v-col
            cols="12"
            sm="4"
            class="text-center"
            v-for="(feature, i) in features"
            :key="i"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                class="card"
                shaped
                :elevation="hover ? 10 : 4"
                :class="{ up: hover }"
              >
                <v-img
                  :src="feature.img"
                  max-width="18%"
                  class="d-block ml-auto mr-auto my-3 fa-solid"
                  :class="{ 'zoom-efect': hover }"
                ></v-img>
                <h1 class="font-weight-regular">{{ feature.title }}</h1>
                <h4
                  style="line-height: 22px !important"
                  class="font-weight-regular subtitle-1"
                >
                  {{ feature.text }}
                </h4>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <div class="font-weight-thin center mb-16 mt-12">
          <h1
            @click="$router.push('/faq')"
            style="cursor: pointer"
            class="text-subtitle-1 mt-1 secondary--text"
          >
            Check out our FAQ's to learn more
          </h1>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    features: [
      {
        img: require("@/assets/fontawesome/circle-1-light.svg"),
        title: "Add your item, FREE",
        text: "Add as many rental listings as you want for FREE and manage them in your dashboard.",
      },
      {
        img: require("@/assets/fontawesome/circle-2-light.svg"),
        title: "Approve booking requests ",
        text: "You decide... Approve or decline a booking based on availability and feedback from other lenders.",
      },
      {
        img: require("@/assets/fontawesome/circle-3-light.svg"),
        title: "Get Paid",
        text: "Once the person has collected the item, we pay you the total rental fee, simple...",
      },
    ],
  }),
};
</script>

<style scoped>
.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
.center {
  display: grid;
  place-items: center;
}
</style>
